/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  buscarUnidad,
  listarProveedores,
  listarSubcuencas,
  listarUnidades,
} from "../api/General";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { isInvalid } from "../utils/forms";
import {
  crearAprovechamientoPluviales,
  crearConexionRedAgua,
  crearPozoAguaSubterranea,
  crearReusoAgua,
  crearTomaAguaSuperficial,
} from "../utils/data";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import AmmountField from "./controls/AmmountField";
import QuestionField from "./controls/QuestionField";
import TextField from "./controls/TextField";
import MeasureField from "./controls/MeasureField";
import Label from "./controls/Label";
import ObjectField from "./controls/ObjectField";
import SelectField from "./controls/SelectField";
import ArrayField from "./controls/ArrayField";
import { TomaAguaSuperficialForm } from "./TomaAguaSuperficialForm";
import { TomaAguaSuperficialList } from "./TomaAguaSuperficialList";
import { PozoAguaSubterraneaForm } from "./PozoAguaSubterraneaForm";
import { PozoAguaSubterraneaList } from "./PozoAguaSubterraneaList";

export default function InfraestructuraForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const { t } = useTranslation();
  const unidadSuperficieCatalog = useCatalog(["unidad", "M2"], () =>
    buscarUnidad("M2"),
  );
  const unidadPotenciaCatalog = useCatalog(["unidad", "HP"], () =>
    buscarUnidad("HP"),
  );
  const unidadGasCatalog = useCatalog(["unidad", "NM3"], () =>
    buscarUnidad("NM3"),
  );
  const unidadElectricidadCatalog = useCatalog(["unidad", "KWH"], () =>
    buscarUnidad("KWH"),
  );
  const unidadCaudalPicoCatalog = useCatalog(["unidad", "M3H"], () =>
    buscarUnidad("M3H"),
  );
  const unidadCaudalMedioCatalog = useCatalog(["unidad", "M3DIA"], () =>
    buscarUnidad("M3DIA"),
  );
  const unidadesEnergiaAlternativaCatalog = useCatalog(
    ["unidades", "energiaAlternativa", "M3ANIO", "TNANIO"],
    () => listarUnidades({ codigo: ["M3ANIO", "TNANIO"] }),
  );
  const prestadoresAguaCatalog = useCatalog(
    ["proveedores", "AGUA"],
    () => listarProveedores({ servicio: "AGUA" }),
  );
  const unidadVolumenCatalog = useCatalog(["unidad", "M3"], () =>
    buscarUnidad("M3"),
  );
  const unidadPorcentualCatalog = useCatalog(["unidad", "PORCENTAJE"], () =>
    buscarUnidad("PORCENTAJE"),
  );
  const unidadProfundidadCatalog = useCatalog(["unidad", "MBBP"], () =>
    buscarUnidad("MBBP"),
  );
  const subcuencasCatalog = useCatalog(["subcuencas"], () =>
    listarSubcuencas({}),
  );
  const loading =
    unidadSuperficieCatalog.loading ||
    unidadPotenciaCatalog.loading ||
    unidadGasCatalog.loading ||
    unidadElectricidadCatalog.loading ||
    unidadCaudalPicoCatalog.loading ||
    unidadCaudalMedioCatalog.loading ||
    unidadesEnergiaAlternativaCatalog.loading ||
    prestadoresAguaCatalog.loading ||
    unidadVolumenCatalog.loading ||
    unidadPorcentualCatalog.loading ||
    unidadProfundidadCatalog.loading ||
    subcuencasCatalog.loading;
  const handleConPozoAbsorbenteChange = (event) =>
    tramiteForm.handleChange(event);
  const handlePotenciaActivaChange = (event) => tramiteForm.handleChange(event);
  const handleConsumoElectricidadChange = (event) =>
    tramiteForm.handleChange(event);
  const handleConsumoGasNaturalChange = (event) =>
    tramiteForm.handleChange(event);
  const handleConEnergiaAlternativaChange = (event) =>
    tramiteForm.handleChange(event);
  const handleFuenteEnergiaAlternativaChange = (event) =>
    tramiteForm.handleChange(event);
  const handleConsumoEnergiaAlternativaChange = (event) =>
    tramiteForm.handleChange(event);
  const handleConCaptacionAguaRed = (event) => tramiteForm.handleChange(event);
  const handleConCaptacionAguaSubterranea = (event) =>
    tramiteForm.handleChange(event);
  const handleConCaptacionAguaSuperficial = (event) =>
    tramiteForm.handleChange(event);
  const handleConAprovechamientoPluviales = (event) =>
    tramiteForm.handleChange(event);
  const handleConReusoAgua = (event) => tramiteForm.handleChange(event);
  const handleSuperficieTotalChange = (event) =>
    tramiteForm.handleChange(event);
  const handleSuperficieProduccionChange = (event) =>
    tramiteForm.handleChange(event);
  const handleConConexionCloacasChange = (event) =>
    tramiteForm.handleChange(event);
  const handleConexionRedAguaChange = (event) =>
    tramiteForm.handleChange(event);
  const handlePozosAguaSubterraneaChange = (event) =>
    tramiteForm.handleChange(event);
  const handleTomasAguaSuperficialChange = (event) =>
    tramiteForm.handleChange(event);
  const handleAprovechamientoPluvialesChange = (event) =>
    tramiteForm.handleChange(event);
  const handleReusoAguaChange = (event) => tramiteForm.handleChange(event);
  useEffect(() => {
    if (!tramiteForm.values.conCaptacionAguaRed) {
      tramiteForm.setFieldValue("conexionRedAgua", undefined, true);
    } else if (!tramiteForm.values.conexionRedAgua) {
      tramiteForm.setFieldValue(
        "conexionRedAgua",
        crearConexionRedAgua(),
        true,
      );
    } else {
      tramiteForm.setFieldValue(
        "conexionRedAgua",
        tramite.conexionRedAgua,
        true,
      );
    }
  }, [tramiteForm.values.conCaptacionAguaRed]);
  useEffect(() => {
    if (!tramiteForm.values.conAprovechamientoPluviales) {
      tramiteForm.setFieldValue("aprovechamientoPluviales", undefined, false);
    } else if (!tramiteForm.values.aprovechamientoPluviales) {
      tramiteForm.setFieldValue(
        "aprovechamientoPluviales",
        crearAprovechamientoPluviales(),
        true,
      );
    } else {
      tramiteForm.setFieldValue(
        "aprovechamientoPluviales",
        tramite.aprovechamientoPluviales,
        false,
      );
    }
  }, [tramiteForm.values.conAprovechamientoPluviales]);
  useEffect(() => {
    if (!tramiteForm.values.conReusoAgua) {
      tramiteForm.setFieldValue("reusoAgua", undefined, true);
    } else if (!tramiteForm.values.reusoAgua) {
      tramiteForm.setFieldValue("reusoAgua", crearReusoAgua(), true);
    } else {
      tramiteForm.setFieldValue("reusoAgua", tramite.reusoAgua, true);
    }
  }, [tramiteForm.values.conReusoAgua]);
  useEffect(() => {
    if (!tramiteForm.values.conEnergiaAlternativa) {
      tramiteForm.setFieldValue("fuenteEnergiaAlternativa", null, true);
    } else if (!tramiteForm.values.fuenteEnergiaAlternativa) {
      tramiteForm.setFieldValue("fuenteEnergiaAlternativa", "", true);
    } else {
      tramiteForm.setFieldValue(
        "fuenteEnergiaAlternativa",
        tramite.fuenteEnergiaAlternativa,
        true,
      );
    }
  }, [tramiteForm.values.conEnergiaAlternativa]);
  useEffect(() => {
    if (!tramiteForm.values.conEnergiaAlternativa) {
      tramiteForm.setFieldValue("consumoEnergiaAlternativa", null, true);
    } else if (!tramiteForm.values.consumoEnergiaAlternativa) {
      tramiteForm.setFieldValue(
        "consumoEnergiaAlternativa",
        { magnitud: 0, unidad: undefined },
        true,
      );
    } else {
      tramiteForm.setFieldValue(
        "consumoEnergiaAlternativa",
        tramite.consumoEnergiaAlternativa,
        true,
      );
    }
  }, [tramiteForm.values.conEnergiaAlternativa]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={4}>
            <AmmountField
              id="superficieTotal"
              name="superficieTotal"
              label={t("tramite.superficieTotal")}
              value={tramiteForm.values?.superficieTotal}
              onChange={handleSuperficieTotalChange}
              unit={unidadSuperficieCatalog.data}
              isInvalid={isInvalid("superficieTotal", tramiteForm)}
              error={t(tramiteForm.errors.superficieTotal)}
              disabled={!isEditable(tramite)}
            />
          </Col>
          <Col lg={4}>
            <AmmountField
              id="superficieProduccion"
              name="superficieProduccion"
              label={t("tramite.superficieProduccion")}
              value={tramiteForm.values?.superficieProduccion}
              onChange={handleSuperficieProduccionChange}
              unit={unidadSuperficieCatalog.data}
              isInvalid={isInvalid("superficieProduccion", tramiteForm)}
              error={t(tramiteForm.errors.superficieProduccion)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <QuestionField
              id="conConexionCloacas"
              name="conConexionCloacas"
              label={t("tramite.conConexionCloacas")}
              value={tramiteForm.values?.conConexionCloacas}
              onChange={handleConConexionCloacasChange}
              isInvalid={isInvalid("conConexionCloacas", tramiteForm)}
              error={t(tramiteForm.errors.conConexionCloacas)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <QuestionField
              id="conPozoAbsorbente"
              name="conPozoAbsorbente"
              label={t("tramite.conPozoAbsorbente")}
              value={tramiteForm.values?.conPozoAbsorbente}
              onChange={handleConPozoAbsorbenteChange}
              isInvalid={isInvalid("conPozoAbsorbente", tramiteForm)}
              error={t(tramiteForm.errors.conPozoAbsorbente)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <AmmountField
              id="potenciaActiva"
              name="potenciaActiva"
              label={t("tramite.potenciaActiva")}
              value={tramiteForm.values?.potenciaActiva}
              onChange={handlePotenciaActivaChange}
              unit={unidadPotenciaCatalog.data}
              isInvalid={isInvalid("potenciaActiva", tramiteForm)}
              error={t(tramiteForm.errors.potenciaActiva)}
              disabled={!isEditable(tramite)}
            />
          </Col>
          <Col md={4}>
            <AmmountField
              id="consumoElectricidad"
              name="consumoElectricidad"
              label={t("tramite.consumoElectricidad")}
              value={tramiteForm.values?.consumoElectricidad}
              onChange={handleConsumoElectricidadChange}
              unit={unidadElectricidadCatalog.data}
              isInvalid={isInvalid("consumoElectricidad", tramiteForm)}
              error={t(tramiteForm.errors.consumoElectricidad)}
              disabled={!isEditable(tramite)}
            />
          </Col>
          <Col md={4}>
            <AmmountField
              id="consumoGasNatural"
              name="consumoGasNatural"
              label={t("tramite.consumoGasNatural")}
              value={tramiteForm.values?.consumoGasNatural}
              onChange={handleConsumoGasNaturalChange}
              unit={unidadGasCatalog.data}
              isInvalid={isInvalid("consumoGasNatural", tramiteForm)}
              error={t(tramiteForm.errors.consumoGasNatural)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conEnergiaAlternativa"
              name="conEnergiaAlternativa"
              label={t("tramite.conEnergiaAlternativa")}
              value={tramiteForm.values?.conEnergiaAlternativa}
              onChange={handleConEnergiaAlternativaChange}
              isInvalid={isInvalid("conEnergiaAlternativa", tramiteForm)}
              error={t(tramiteForm.errors.conEnergiaAlternativa)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <TextField
              id="fuenteEnergiaAlternativa"
              name="fuenteEnergiaAlternativa"
              label={t("tramite.fuenteEnergiaAlternativa")}
              value={tramiteForm.values?.fuenteEnergiaAlternativa}
              onChange={handleFuenteEnergiaAlternativaChange}
              isInvalid={isInvalid("fuenteEnergiaAlternativa", tramiteForm)}
              error={t(tramiteForm.errors.fuenteEnergiaAlternativa)}
              disabled={
                !isEditable(tramite) ||
                !tramiteForm.values.conEnergiaAlternativa
              }
            />
          </Col>
          <Col lg={6}>
            <MeasureField
              id="consumoEnergiaAlternativa"
              name="consumoEnergiaAlternativa"
              label={t("tramite.consumoEnergiaAlternativa")}
              value={tramiteForm.values?.consumoEnergiaAlternativa}
              onChange={handleConsumoEnergiaAlternativaChange}
              units={unidadesEnergiaAlternativaCatalog.data}
              isInvalid={isInvalid("consumoEnergiaAlternativa", tramiteForm)}
              error={t(tramiteForm.errors.consumoEnergiaAlternativa)}
              disabled={
                !isEditable(tramite) ||
                !tramiteForm.values.conEnergiaAlternativa
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <QuestionField
              id="conCaptacionAguaRed"
              name="conCaptacionAguaRed"
              label={t("tramite.conCaptacionAguaRed")}
              value={tramiteForm.values?.conCaptacionAguaRed}
              onChange={handleConCaptacionAguaRed}
              isInvalid={isInvalid("conCaptacionAguaRed", tramiteForm)}
              error={t(tramiteForm.errors.conCaptacionAguaRed)}
              disabled={!isEditable(tramite)}
            />
          </Col>
          <Col>
            <QuestionField
              id="conCaptacionAguaSubterranea"
              name="conCaptacionAguaSubterranea"
              label={t("tramite.conCaptacionAguaSubterranea")}
              value={tramiteForm.values?.conCaptacionAguaSubterranea}
              onChange={handleConCaptacionAguaSubterranea}
              isInvalid={isInvalid("conCaptacionAguaSubterranea", tramiteForm)}
              error={t(tramiteForm.errors.conCaptacionAguaSubterranea)}
              disabled={!isEditable(tramite)}
            />
          </Col>
          <Col>
            <QuestionField
              id="conCaptacionAguaSuperficial"
              name="conCaptacionAguaSuperficial"
              label={t("tramite.conCaptacionAguaSuperficial")}
              value={tramiteForm.values?.conCaptacionAguaSuperficial}
              onChange={handleConCaptacionAguaSuperficial}
              isInvalid={isInvalid("conCaptacionAguaSuperficial", tramiteForm)}
              error={t(tramiteForm.errors.conCaptacionAguaSuperficial)}
              disabled={!isEditable(tramite)}
            />
          </Col>
          <Col>
            <QuestionField
              id="conAprovechamientoPluviales"
              name="conAprovechamientoPluviales"
              label={t("tramite.conAprovechamientoPluviales")}
              value={tramiteForm.values?.conAprovechamientoPluviales}
              onChange={handleConAprovechamientoPluviales}
              isInvalid={isInvalid("conAprovechamientoPluviales", tramiteForm)}
              error={t(tramiteForm.errors.conAprovechamientoPluviales)}
              disabled={!isEditable(tramite)}
            />
          </Col>
          <Col>
            <QuestionField
              id="conReusoAgua"
              name="conReusoAgua"
              label={t("tramite.conReusoAgua")}
              value={tramiteForm.values?.conReusoAgua}
              onChange={handleConReusoAgua}
              isInvalid={isInvalid("conReusoAgua", tramiteForm)}
              error={t(tramiteForm.errors.conReusoAgua)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ObjectField
              name="conexionRedAgua"
              label={t("tramite.conexionRedAgua")}
              value={tramiteForm.values.conexionRedAgua}
              onChange={handleConexionRedAguaChange}
              disabled={
                !isEditable(tramite) || !tramiteForm.values.conCaptacionAguaRed
              }
            >
              {({ value, setProperty, disabled }) => {
                return (
                  <Grid>
                    <Row>
                      <Col>
                        <SelectField
                          id="conexionRedAgua_prestador"
                          name="conexionRedAgua.prestador"
                          label={t("aguaRed.prestador")}
                          value={value?.prestador}
                          onChange={(event) => {
                            event.preventDefault();
                            setProperty("prestador", event.target.value);
                          }}
                          options={prestadoresAguaCatalog.data}
                          valueAttr="codigo"
                          labelAttr="nombre"
                          emptyLabel="..."
                          isInvalid={isInvalid(
                            "conexionRedAgua.prestador",
                            tramiteForm,
                          )}
                          error={t(
                            tramiteForm.errors.conexionRedAgua?.prestador,
                          )}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <AmmountField
                          id="conexionRedAgua_caudalMedio"
                          name="conexionRedAgua.caudalMedio"
                          label={t("aguaRed.caudalMedio")}
                          value={value?.caudalMedio}
                          onChange={(event) => {
                            event.preventDefault();
                            setProperty("caudalMedio", event.target.value);
                          }}
                          unit={unidadCaudalMedioCatalog.data}
                          isInvalid={isInvalid(
                            "conexionRedAgua.caudalMedio",
                            tramiteForm,
                          )}
                          error={t(
                            tramiteForm.errors.conexionRedAgua?.caudalMedio,
                          )}
                          disabled={disabled}
                        />
                      </Col>
                      <Col lg={4}>
                        <AmmountField
                          id="conexionRedAgua_caudalPico"
                          name="conexionRedAgua.caudalPico"
                          label={t("aguaRed.caudalPico")}
                          value={value?.caudalPico}
                          onChange={(event) => {
                            event.preventDefault();
                            setProperty("caudalPico", event.target.value);
                          }}
                          unit={unidadCaudalPicoCatalog.data}
                          isInvalid={isInvalid(
                            "conexionRedAgua.caudalPico",
                            tramiteForm,
                          )}
                          error={t(
                            tramiteForm.errors.conexionRedAgua?.caudalPico,
                          )}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  </Grid>
                );
              }}
            </ObjectField>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="pozosAguaSubterranea"
              name="pozosAguaSubterranea"
              label={t("tramite.pozosAguaSubterranea")}
              createItem={crearPozoAguaSubterranea}
              value={tramiteForm.values.pozosAguaSubterranea}
              onChange={handlePozosAguaSubterraneaChange}
              isInvalid={isInvalid("pozosAguaSubterranea", tramiteForm)}
              error={
                (tramiteForm.errors.pozosAguaSubterranea instanceof Array &&
                  t("errors.tramite.pozosAguaSubterranea.many")) ||
                t(tramiteForm.errors.pozosAguaSubterranea)
              }
              disabled={
                !isEditable(tramite) ||
                !tramiteForm.values.conCaptacionAguaSubterranea
              }
            >
              {({
                value: pozosAguaSubterranea,
                append,
                replace,
                remove,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <PozoAguaSubterraneaForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={pozosAguaSubterranea.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          unidadCaudalMedio={unidadCaudalMedioCatalog.data}
                          unidadCaudalPico={unidadCaudalPicoCatalog.data}
                          unidadProfundidad={unidadProfundidadCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <PozoAguaSubterraneaList
                        value={pozosAguaSubterranea}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="tomasAguaSuperficial"
              name="tomasAguaSuperficial"
              label={t("tramite.tomasAguaSuperficial")}
              createItem={crearTomaAguaSuperficial}
              value={tramiteForm.values.tomasAguaSuperficial}
              onChange={handleTomasAguaSuperficialChange}
              isInvalid={isInvalid("tomasAguaSuperficial", tramiteForm)}
              error={
                (tramiteForm.errors.tomasAguaSuperficial instanceof Array &&
                  t("errors.tramite.tomasAguaSuperficial.many")) ||
                t(tramiteForm.errors.tomasAguaSuperficial)
              }
              disabled={
                !isEditable(tramite) ||
                !tramiteForm.values.conCaptacionAguaSuperficial
              }
            >
              {({
                value: tomasAguaSuperficial,
                append,
                replace,
                remove,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <TomaAguaSuperficialForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={tomasAguaSuperficial.length}
                          select={select}
                          append={append}
                          remove={remove}
                          replace={replace}
                          unidadCaudalMedio={unidadCaudalMedioCatalog.data}
                          unidadCaudalPico={unidadCaudalPicoCatalog.data}
                          subcuencas={subcuencasCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <TomaAguaSuperficialList
                        value={tomasAguaSuperficial}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
        <Label>{t("tramite.aprovechamientoPluviales")}</Label>
        <Row>
          <Col>
            <ObjectField
              id="aprovechamientoPluviales"
              name="aprovechamientoPluviales"
              value={tramiteForm.values.aprovechamientoPluviales}
              onChange={handleAprovechamientoPluvialesChange}
              disabled={
                !isEditable(tramite) ||
                !tramiteForm.values.conAprovechamientoPluviales
              }
            >
              {({ value, setProperty, disabled }) => (
                <Grid>
                  <Row>
                    <Col lg={4}>
                      <AmmountField
                        id="aprovechamientoPluviales_volumenTanque"
                        name="aprovechamientoPluviales.volumenTanque"
                        label={t("aprovechamientoPluviales.volumenTanque")}
                        value={value?.volumenTanque}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("volumenTanque", event.target.value);
                        }}
                        unit={unidadVolumenCatalog.data}
                        isInvalid={isInvalid(
                          "aprovechamientoPluviales.volumenTanque",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.aprovechamientoPluviales
                            ?.volumenTanque,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                    <Col lg={4} smOffset={2}>
                      <AmmountField
                        id="aprovechamientoPluviales_aprovechamiento"
                        name="aprovechamientoPluviales.aprovechamiento"
                        label={t("aprovechamientoPluviales.aprovechamiento")}
                        value={value?.aprovechamiento}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("aprovechamiento", event.target.value);
                        }}
                        unit={unidadPorcentualCatalog.data}
                        isInvalid={isInvalid(
                          "aprovechamientoPluviales.aprovechamiento",
                          tramiteForm,
                        )}
                        error={t(
                          tramiteForm.errors.aprovechamientoPluviales
                            ?.aprovechamiento,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ObjectField>
          </Col>
        </Row>
        <Label>{t("tramite.reusoAgua")}</Label>
        <Row>
          <Col>
            <ObjectField
              id="reusoAgua"
              name="reusoAgua"
              value={tramiteForm.values.reusoAgua}
              onChange={handleReusoAguaChange}
              disabled={
                !isEditable(tramite) || !tramiteForm.values.conReusoAgua
              }
            >
              {({ value, setProperty, disabled }) => (
                <Grid>
                  <Row>
                    <Col lg={4}>
                      <AmmountField
                        id="reusoAgua_volumenTanque"
                        name="reusoAgua.volumenTanque"
                        label={t("reusoAgua.volumenTanque")}
                        value={value?.volumenTanque}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("volumenTanque", event.target.value);
                        }}
                        unit={unidadVolumenCatalog.data}
                        isInvalid={isInvalid(
                          "reusoAgua.volumenTanque",
                          tramiteForm,
                        )}
                        error={t(tramiteForm.errors.reusoAgua?.volumenTanque)}
                        disabled={disabled}
                      />
                    </Col>
                    <Col lg={4} smOffset={2}>
                      <AmmountField
                        id="reusoAgua_aprovechamiento"
                        name="reusoAgua.aprovechamiento"
                        label={t("reusoAgua.aprovechamiento")}
                        value={value?.aprovechamiento}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("aprovechamiento", event.target.value);
                        }}
                        unit={unidadPorcentualCatalog.data}
                        isInvalid={isInvalid(
                          "reusoAgua.aprovechamiento",
                          tramiteForm,
                        )}
                        error={t(tramiteForm.errors.reusoAgua?.aprovechamiento)}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ObjectField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
